query RetourQuery($uri: String, $siteId: Int) {
  retourResolveRedirect(uri: $uri, siteId: $siteId) {
    redirectDestUrl
    redirectHttpCode
    enabled
  }
}
